<template>
  <div class="container">
    <MenuTeacher />
    <div class="teach-container">
      <router-view />
    </div>
  </div>
</template>

<script>
import MenuTeacher from "../components/MenuTeacher";
import SideMenuTeacher from "../components/SideMenuTeacher";
import Footer from "../components/Footer";
export default {
  name: "MenuLayout",
  components: {
    MenuTeacher,
    Footer,
    SideMenuTeacher,
  },
  data() {
    return {};
  },
  methods: {
    handleClick(e) {
      console.log("click ", e);
    },
  },
};
</script>

<style scoped>
.container {
  background: url(~@assets/theme/xmw/student-bg.png) #fafcfc;
  background-size: 100%;
  background-repeat: no-repeat;
  min-height: 100vh;
}
/* .teach-container {
  width: 1200px;
  margin: 10px auto;
} */
.ant-layout {
  background: transparent;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.ant-card {
  margin: 0 20px;
}
</style>